import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import RouteHistory from "go-core/utils/routeHistory";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import { BundleApi } from "../../../../../../../../../../services/Api/Organization/types";
import BundleForm from "../../components/BundleForm/BundleForm";

interface StateType {
	copiedItem: BundleApi;
}

const OrganizationBundleNewPage = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const { addFlash } = useFlash();
	const organization = useSelector(selectOrganization);
	const { state } = useLocation<StateType>();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>();

	useEffect(() => {
		handleChangeTabTitle(t("modules.bundle.header.new.title"));
		fetchResources();
	}, []);

	const goBack = () => RouteHistory.goBack(history, `/${organization.id}/documents/bundles`);

	const fetchResources = async () => {
		try {
			const params = {
				resource_name: "BUNDLE",
				custom_field_resource_type: "BUNDLE",
				custom_field_permission_scope: "WRITE",
			};
			const res = await apiOrganization.getResourceTypes(params);
			setCustomFieldsConfig(res.custom_fields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!customFieldsConfig) return <LoadingContainer />;

	return (
		<>
			<Header title={t("modules.bundle.header.new.title")} back={goBack} />
			<BundleForm bundle={state?.copiedItem} customFieldsConfig={customFieldsConfig} />
		</>
	);
};

export default OrganizationBundleNewPage;
